import React, { useCallback, useState } from 'react';

import { ErrorModal } from 'components/ui/modal/ErrorModal';

type UseLoadingWithErrorHandlingReturn = {
  submitting: boolean;
  setSubmitting: React.Dispatch<React.SetStateAction<boolean>>;
  showErrorModal: (error?: any) => void;
  ErrorModalComponent: React.ReactNode | null;
};

export const useLoadingWithErrorHandling = (): UseLoadingWithErrorHandlingReturn => {
  const [submitting, setSubmitting] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const showErrorModal = useCallback((error?: any) => {
    // Don't show error modal for 401 authentication errors
    // The auth interceptor will handle logout and redirect
    if (error?.response?.status === 401) {
      return;
    }
    setIsErrorModalOpen(true);
  }, []);

  const closeErrorModal = useCallback(() => {
    setIsErrorModalOpen(false);
  }, []);

  const ErrorModalComponent = isErrorModalOpen ? <ErrorModal onCancelClick={closeErrorModal} btnText="Close" /> : null;

  return { submitting, setSubmitting, showErrorModal, ErrorModalComponent };
};
